import HomeLink from "./HomeLink";
import PercentBar from "./PercentBar";
import TopBanner from "./TopBanner";
import CreditPanel from "./CreditPanel";

export default function MintGods() {
    // const navigate = useNavigate();
    const purchase = () => {
        console.log('purchasing...');
        // navigate('/purchase');
    }

    return (
        <div className="App-header">
            <div style={{width: '80%', minWidth: '750px'}}>
                <TopBanner />
            </div>
            <div className='flexRowTop' style={{width: '80%', minWidth: '750px', border: 'solid 2px grey', borderRadius: '10px', padding: '15px', marginBottom: '10px'}}>
                <div className='flexColumn' style={{width: '50%', minWidth: '350px', padding: '15px', gap: '15px'}}>
                    <div className='launchTitle'>Blockchain&nbsp;Gods</div>
                    <div>
                        Take your God into a revolutionary P2E game world.
                    </div>
                    <div>
                        Will you choose to use your powers for good, or for evil? The choice is yours.
                    </div>
                    <div>
                        Earn $BLOOD by staking your God and completing quests in the game world. Play to level up your God.
                        Find items and other awesome loot, including one of three powerful Legendary items!!
                    </div>
                    <div>
                        Each God has a special ultimate ability - level up your God to level 50 to unlock it...
                        and be careful, your destructive power can wreck havoc upon the game world.
                    </div>
                    <div>
                        <div style={{marginBottom: '10px'}}>Supply: 6666 Gods</div>
                        <div style={{margin: '0px'}}><img alt='BLOOD' src='/4mint/bloodcoin-64.png' style={{width: '64px', height: '64px'}}/></div>
                        <div style={{margin: '0px'}}>Native coin: $BLOOD</div>
                    </div>
                </div>

                <div className='flexColumn' style={{width: '50%', minWidth: '350px', padding: '15px'}}>
                    <img alt='' src='/4mint/gods.gif' width='100%' style={{borderRadius: '15px'}}/>
                    <div className='smallText' style={{width: '100%', display: 'flex'}}>
                        <div style={{width: '50%', textAlign: 'left'}}>WL Price: 1 SOL</div>
                        <div style={{width: '50%', textAlign: 'right'}}>Minted 25% (1 / 4)</div>
                    </div>
                    <div style={{width: '100%', alignItems: 'flex-end'}}><PercentBar percent={25}/></div>
                    <div className='flexRow' style={{marginTop: '5px'}}>
                        <button className='mintButton' style={{padding: '10px'}} onClick={purchase}>Mint</button>
                    </div>
                </div>
            </div>
            <CreditPanel/>
            <HomeLink/>
        </div>
    )
}
